export const comments_3389325 = {"data":{"data":[],"links":{}}}